export default "__VITE_ASSET__37816a50__"